export const URL_MINORS_TERM =
  process.env.NODE_ENV === 'development'
    ? 'https://drvirtual-hml.s3.sa-east-1.amazonaws.com/termos-uso/Termo_para_crian%C3%A7as_e_adolescentes.pdf'
    : 'https://drvirtual.s3.sa-east-1.amazonaws.com/termos-uso/Termo_para_crian%C3%A7as_e_adolescentes.pdf'

export const PARTNER_URL = 'https://www.bradescoseguros.com.br/clientes'

export const EVENT_NAME = {
  'dados-dependente': 'at_patient_activation_minor_term_modal',
  escolha: 'at_patient_multiprofile_minor_term_modal',
}
